import React, { createContext, useContext, useMemo } from 'react';
const BackgroundContext = createContext({
    backgroundType: 'main',
    backgroundClsx: ['bg-background'],
    text400Clsx: ['text-content-on-background-subdued'],
    text500Clsx: ['text-content-on-background-subdued'],
    text900Clsx: ['text-content-on-background'],
});
export const BackgroundProvider = ({ backgroundType, children, }) => {
    const value = useMemo(() => {
        const backgroundClsx = [
            backgroundType === 'main' && 'bg-background',
            backgroundType === 'surface' && 'bg-surface',
            backgroundType === 'secondary' && 'bg-topbar',
        ];
        const text500Clsx = [
            backgroundType === 'main' && 'text-content-on-background-subdued',
            backgroundType === 'surface' && 'text-content-subdued',
            backgroundType === 'secondary' && 'text-content-on-topbar',
        ];
        const text400Clsx = [
            backgroundType === 'main' && 'text-content-on-background-subdued',
            backgroundType === 'surface' && 'text-content-subdued',
            backgroundType === 'secondary' && 'text-content-on-topbar',
        ];
        const text900Clsx = [
            backgroundType === 'main' && 'text-content-on-background',
            backgroundType === 'surface' && 'text-content',
            backgroundType === 'secondary' && 'text-content-on-topbar',
        ];
        return {
            backgroundType,
            backgroundClsx,
            text400Clsx,
            text500Clsx,
            text900Clsx,
        };
    }, [backgroundType]);
    return (React.createElement(BackgroundContext.Provider, { value: value }, children));
};
export const useBackgroundContext = () => {
    return useContext(BackgroundContext);
};
//# sourceMappingURL=BackgroundContext.js.map